/* Skinsy common questions — the accordion.

   The product page's toggle, extracted: one question open at a time across
   the page, the button's aria-expanded is the only state, the answer's
   `hidden` follows it. A hash in the URL (#sk-fq-3) opens that row on load,
   so an answer can be linked to from WhatsApp. */
(function () {
  'use strict';

  document.querySelectorAll('[data-skinsy-faq]').forEach(function (root) {
    var buttons = function () { return root.querySelectorAll('[data-faq-toggle]'); };

    var setOpen = function (btn) {
      buttons().forEach(function (b) {
        var on = b === btn;
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
        var p = root.querySelector('#' + b.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    };

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-faq-toggle]');
      if (!t || !root.contains(t)) return;
      setOpen(t.getAttribute('aria-expanded') === 'true' ? null : t);
    });

    if (location.hash) {
      var target = root.querySelector('[aria-controls="' + location.hash.slice(1) + '"]');
      if (target) setOpen(target);
    }
  });
})();
